export class ContentWindowMessenger {
    constructor(contentWindows, currentDocument = document) {
        this.contentWindows = contentWindows;
        this.currentDocument = currentDocument;
    }
    postMessage(message) {
        this.contentWindows.forEach((contentWindow) => {
            const element = this.currentDocument.getElementById(contentWindow.id);
            // @ts-ignore
            if (element && element.contentWindow) {
                // @ts-ignore
                element.contentWindow.postMessage(message, contentWindow.targetOrigin);
            }
        });
    }
}
//# sourceMappingURL=ContentWindowMessenger.js.map